var map = {
	"./IMG_20250331_004920.jpg": 512,
	"./IMG_20250331_004924.jpg": 3674,
	"./IMG_20250331_004930.jpg": 445,
	"./IMG_20250421_234833.jpg": 9959,
	"./IMG_20250421_234837.jpg": 6571,
	"./IMG_20250421_234900.jpg": 4029,
	"./IMG_20250421_234914.png": 3041,
	"./IMG_20250421_234919.jpg": 3119,
	"./IMG_20250421_234920.jpg": 5413,
	"./IMG_20250421_235500.jpg": 3508,
	"./IMG_2794.jpg": 8694,
	"./Roof1.jpg": 8779,
	"./Roof2.jpg": 2066,
	"./Roof3.jpg": 179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5441;